import React, { useEffect, useState } from 'react';
import './InstagramEmbed.css';
import { getInstagramPosts } from '../services/galleryService';

const InstagramHighlights = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getInstagramPosts().then(setPosts);
  }, []);

  return (
    <div className="instagram-page">
      <div className="page-headerz">
        <h1 className="slide-left">Our Instagram Highlights</h1>
      </div>

      <div className="insta-grid slide-up">
        {posts.map((post, index) => (
          <a href={post.Link} target="_blank" rel="noopener noreferrer" className="insta-card" key={index}>
            <img src={post.Image} alt={post.Title} />
            <p>{post.Title}</p>
          </a>
        ))}
      </div>

      <div className="insta-button slide-up">
        <a
          href="https://www.instagram.com/atelierbyshriji?igsh=MWg2dzlqaXZ1ZTRtNw%3D%3D&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
        >
          See more on our Instagram page
        </a>
      </div>
    </div>
  );
};

export default InstagramHighlights;
